import { Pomieszczenie } from "../pomieszczenia/pomieszczenie";

export class PobierzDaneDoWyboruRaportuRezultat {
    adresLokalizacji: string;
    pomieszczenia: Array<Pomieszczenie> = new Array();
}